<template>
    <div>

        <!-- Verjaardagen -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-user"></i>
                Verjaardagen
            </h2>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#birthdays" aria-expanded="true" aria-controls="birthdays">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">
            <div class="collapse" :class="{'show': componentIsVisable}" id="birthdays">
                <div class="birthdays">
                    <div v-if="birthdayTodayItems.length > 0 || birthdayFutureitems.length > 0">
                        <div class="highlight mb-3">
                            <div v-for="item of birthdayTodayItems">
                                <img :src="item.avatar">
                                <p class="fw-semibold mb-0">
                                    {{ item.name }}
                                </p>
                                <p class="mb-0 text-sm text-lightgrey">
                                    Vandaag {{ item.age }} jaar
                                </p>
                            </div>
                        </div>
                        <div class="d-flex flex-column gap-2 pt-1">
                            <div class="birthday" v-for="item of birthdayFutureitems">
                                <img :src="item.avatar">
                                <div>
                                    <p class="text-sm mb-0 fw-semibold">
                                        {{ item.name }}
                                    </p>
                                    <p class="text-xs text-lightgrey mb-0">
                                        {{ item.birthdate }}, {{ item.age }} jaar
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        Geen verjaardagen deze week
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'birthdays',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                birthdayTodayItems: [{
                    id: '',
                    avatar: '',
                    name: '',
                    birthdate: '',
                    age: '',
                }],
                birthdayFutureitems: [{
                    id: '',
                    avatar: '',
                    name: '',
                    birthdate: '',
                    age: '',
                }],

                componentId: 'birthdays-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getBirthdays();
                }
            },
            getBirthdays() {
                axios.get('api/birthdays')
                    .then(response => {
                        this.birthdayTodayItems = response.data.birthdayTodayItems;
                        this.birthdayFutureitems = response.data.birthdayFutureitems;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
        },
        mounted() {
            if(this.isVisible) {
                this.getBirthdays();
            } else {
                this.loading = false;
            }
        },
        created() {},
    }
</script>
